<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/YHBJHG/tc-custom/9781250029539.jpg?1725275644455" alt="This image is the cover for the book Survivor"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Survivor
      </h1>
      <p class="bookDescription body article font2">
        <b>“[A] deeply intimate account . . . Masterfully conveys the grim absurdity of the Nazi mentality and the utter dejection of the concentration-camp prisoner.” —<i>Kirkus Reviews</i></b><br/><br/>Sam Pivnik is the ultimate survivor from a world that no longer exists. On fourteen occasions he should have been killed, but luck, his physical strength, and his determination not to die all played a part in Sam Pivnik living to tell his extraordinary story.<br/><br/>In 1939, on his thirteenth birthday, Pivnik’s life changed forever when the Nazis invaded Poland. He survived the two ghettoes set up in his home town of Bedzin and six months on Auschwitz’s notorious <i>Rampe Kommando</i> where prisoners were either taken away for entry to the camp or gassing. After this harrowing experience he was sent to work at the brutal Fürstengrube mining camp. He could have died on the ‘Death March’ that took him west as the Third Reich collapsed and he was one of only a handful of people who swam to safety when the Royal Air Force sank the prison ship <i>Cap Arcona</i> in 1945, mistakenly believing it to be carrying fleeing members of the SS.<br/><br/>He eventually made his way to London where he found people too preoccupied with their own wartime experiences on the Home Front to be interested in what had happened to him.<br/><br/>Now in his eighties, Sam Pivnik tells for the first time the story of his life, a true tale of survival against the most extraordinary odds.<br/><br/><b>“Absorbing and often riveting . . . another worthy addition to the books on the horrors of Nazi occupation.” —<i>Booklist</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sam Pivnik
      </h2>
      
      <p class="authorDescription body article"><P>SAM PIVNIK was born in Poland in 1926. In 1943 his family was sent to Auschwitz II where Pivnik's parents and five siblings were murdered. After many brushes with death, Pivnik was liberated by the British Army in 1945. He now shares his memories through lectures and talks.<br>M J TROW is the author of many books on historical subjects, including <I>War Crimes: Underworld Britain in the Second World War</I>. He studied military history at King's College, London.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c5f51542